import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiCalendar, FiClock, FiX } from "react-icons/fi";

const AddEventModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Add New Event</Modal.Title>

        <button className="close-btn" onClick={handleClose}>
          <FiX />
        </button>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Event Name */}
          <Form.Group className="mb-3">
            <Form.Label>Event Name</Form.Label>
            <Form.Control />
          </Form.Group>

          {/* Event Date */}
          <Form.Group className="mb-3">
            <Form.Label>Event Date</Form.Label>
            <div className="input-icon">
              <Form.Control />
              <FiCalendar />
            </div>
          </Form.Group>

          {/* Time */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Start Time</Form.Label>
                <div className="input-icon">
                  <Form.Control />
                  <FiClock />
                </div>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>End Time</Form.Label>
                <div className="input-icon">
                  <Form.Control />
                  <FiClock />
                </div>
              </Form.Group>
            </Col>
          </Row>

          {/* Location */}
          <Form.Group className="mb-3">
            <Form.Label>Event Location</Form.Label>
            <Form.Control />
          </Form.Group>

          {/* Description */}
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">
          Add Event
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEventModal;